import { Document, Paragraph, ImageRun, Packer, SectionType, HeadingLevel, AlignmentType } from "docx";
import { saveAs } from "file-saver";

export async function criarDocumentoWord(questoes, titulo, logoUrl) {
    const margens = 720;
    const margenTop = 400;
    const response = await fetch(logoUrl);
    const imageBlob = await response.blob();

    const width = 320;  // Largura fixa para todas as imagens
    const aspectRatio = 16 / 9; // Proporção comum para imagens
    const height = width / aspectRatio;

    const arrayBuffer = await new Response(imageBlob).arrayBuffer();
    const sections = [
        {
            properties: {
                type: SectionType.CONTINUOUS,
                page: {
                    margin: {
                        top: margenTop,
                        right: margens,
                        bottom: margens,
                        left: margens
                    },
                }
            },
            children: [
                new Paragraph({
                    alignment: AlignmentType.RIGHT,
                    children: [
                        new ImageRun({
                            data: arrayBuffer,
                            transformation: {
                                width: 180,
                                height: 50,
                            },
                            floating: {
                                horizontalPosition: {
                                    offset: 5400000,
                                },
                                verticalPosition: {
                                    offset: 440000,
                                }
                            }

                        }),
                    ]
                }),
                new Paragraph({
                    text: "ESCOLA SESI DE ENSINO MÉDIO",
                    style: "Alternativas"
                }),
                new Paragraph({
                    text: "Albino Marques Gomes",
                    style: "TextoApoio"
                }),
                new Paragraph({
                    text: titulo,
                    style: "Titulo"
                })
            ],
        },
        {
            properties: {
                type: SectionType.CONTINUOUS,
                column: {
                    space: 360,
                    count: 2,
                },
                page: {
                    margin: {
                        top: margenTop,
                        right: margens,
                        bottom: margens,
                        left: margens
                    },
                },
            },
            children: [
                new Paragraph({
                    text: "Nome: ________________________________________",
                    style: "TextoApoio"
                }),
                new Paragraph({
                    text: "Turma: _______________________________________",
                    style: "TextoApoio"
                })
            ]
        }
    ];

    let childrenSessaoQuestoes = [];

    for (const questao of questoes) {
        const children = [
            new Paragraph({
                text: `Questão ${questoes.indexOf(questao) + 1}`,
                style: "NumeroPergunta"
            }),
            ...(questao.texto ? [
                new Paragraph({
                    text: questao.texto,
                    style: "TextoApoio"
                })
            ] : []),
            new Paragraph({
                text: questao.pergunta,
                style: "Pergunta"
            }),
            ...['a', 'b', 'c', 'd', 'e'].map(letter => questao[letter] ? new Paragraph({
                text: `${letter}) ${questao[letter]}`,
                style: "Alternativas"
            }) : []).filter(Boolean)
        ];

        if (questao.imagem) {
            try {
                const { blob, width, height, format } = await loadImageAndGetDimensions(questao.imagem);
                const imageRun = new ImageRun({
                    data: blob,
                    transformation: {
                        width,
                        height
                    }
                });
                children.splice(1, 0, new Paragraph({ children: [imageRun] }));
            } catch (error) {
                console.error("Erro ao processar a imagem: ", error);
            }
        }

        childrenSessaoQuestoes.push(...children);
    }

    sections.push({
        properties: {
            type: SectionType.CONTINUOUS,
            column: {
                space: 360,
                count: 2,
            },
            page: {
                margin: {
                    top: margenTop,
                    right: margens,
                    bottom: margens,
                    left: margens
                },
            }
        },
        children: childrenSessaoQuestoes
    })


    const doc = new Document({
        creator: "Minha Escola",
        title: titulo,
        styles: {
            paragraphStyles: [
                {
                    id: "NumeroPergunta",
                    name: "Número da Pergunta",
                    basedOn: "Heading3",
                    next: "Normal",
                    quickFormat: true,
                    run: {
                        bold: true,
                        size: 24,
                        color: "000000",
                        font: {
                            name: "Calibri",
                        },
                    },
                    paragraph: {
                        spacing: {
                            after: 60,
                            before: 240
                        },
                    }
                },
                {
                    id: "TextoApoio",
                    name: "Texto de Apoio",
                    basedOn: "Normal",
                    next: "Pergunta",
                    quickFormat: true,
                    run: {
                        size: 22,
                        font: {
                            name: "Calibri",
                        },
                    },
                    paragraph: {
                        spacing: {
                            after: 120
                        },
                    }
                },
                {
                    id: "Pergunta",
                    name: "Pergunta",
                    basedOn: "Normal",
                    next: "Normal",
                    quickFormat: true,
                    run: {
                        size: 22,
                        font: {
                            name: "Calibri",
                        },
                    },
                    paragraph: {
                        spacing: {
                            after: 120
                        },
                    }
                },
                {
                    id: "Alternativas",
                    name: "Alternativas",
                    basedOn: "Normal",
                    quickFormat: true,
                    run: {
                        size: 22,
                        font: {
                            name: "Calibri",
                        },
                    }
                },
                {
                    id: "Titulo",
                    name: "Título",
                    basedOn: "Normal",
                    quickFormat: true,
                    run: {
                        size: 32,
                        bold: true,
                        font: {
                            name: "Calibri",
                        },
                    },
                    paragraph: {
                        spacing: {
                            after: 300
                        },
                    }
                }

            ]
        },
        sections: sections
    });

    // Salvar o documento
    const blob = await Packer.toBlob(doc);
    saveAs(blob, `${titulo}.docx`);
    return true
}


async function loadImageAndGetDimensions(imageUrl, fixedWidth = 320) {
    const response = await fetch(imageUrl);
    if (!response.ok) {
        throw new Error(`Falha ao carregar a imagem: ${response.statusText}`);
    }
    const imageBlob = await response.blob();

    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const height = img.naturalHeight * (fixedWidth / img.naturalWidth);
            resolve({
                blob: imageBlob,
                width: fixedWidth,
                height: height,
                format: imageUrl.split('.').pop() // Assume que a URL da imagem contém uma extensão de arquivo
            });
        };
        img.onerror = () => reject(new Error('Erro ao carregar a imagem para obter dimensões.'));
        img.src = URL.createObjectURL(imageBlob);
    });
}


